import template from './error.html';
import './error.less';

const ErrorContainer = {
  bindings: {},
  template
};

export default ErrorContainer;



// WEBPACK FOOTER //
// ./src/containers/error/error.component.js